import { getRowsPerPage } from "../../../utils/utils";
import { BUSINESS_UNIT } from "../../../utils/PreviousSession.constants"
export const filterDataOnRoles = (data, isEdibleOilsRole, isCocoaRole, isAnimalFeedRole, isGrainsRole, isCornRole) => {
    return data.filter((d) => {
      return (
        (d.channel === BUSINESS_UNIT.EDIBLE_OILS && isEdibleOilsRole) ||
        (d.channel === BUSINESS_UNIT.COCOA && isCocoaRole) ||
        (d.channel === BUSINESS_UNIT.ANIMAL_FEED && isAnimalFeedRole) ||
        (d.channel === BUSINESS_UNIT.GRAINS && isGrainsRole) ||
        (d.channel === BUSINESS_UNIT.CORN && isCornRole)
      );
    });
  };

export {getRowsPerPage};